import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      it: {
        translation: {
          "":""

          ,"MESSAGE_NO_QUALIFICHE":"Utente non convenzionato alla Presentazione Documenti"
          ,"MESSAGE_CF_UL_ERRATA":"L'Utente non risulta abilitato come delegato dell'utenza di lavoro selezionata (si rimanda alla sezione 'Gestione utenza' della piattaforma Sister)"
          ,"MESSAGE_CONVENZIONE_SELEZIONATA":"La convenzione è stata salvata"
          
          ,"HOME_BREADCRUMB_TITLE": "Home"
          ,"HOME_BREADCRUMB_ARIALABEL": "Vai alla pagina Home"
          ,"TRASMISSIONE_PEGNO_BREADCRUMB_TITLE":"Trasmissione"
          ,"TRASMISSIONE_PEGNO_BREADCRUMB_ARIALABEL":"Vai alla pagina Trasmissione"
          ,"RICEVUTE_PEGNO_BREADCRUMB_TITLE":"Ricevute"
          ,"RICEVUTE_PEGNO_BREADCRUMB_ARIALABEL":"Vai alla pagina Ricevute"
          
          ,"CONTROLLO_TITLE":"Controllo plico"
          ,"FORNITURA":"Fornitura"
          ,"RESTITUZIONE_DUPLO_RICHIESTA_TITLE":"Richiesta di restituzione del duplo"
          ,"RESTITUZIONE_DUPLO_RICHIESTA_PARAGRAFO":"Per la restituzione del Certificato di eseguita formalità (Duplo), si inseriscano nei campi sottostanti i dati presenti nella Ricevuta di richiesta formalità (Modello 68)."
          ,"RESTITUZIONE_DUPLO_RICHIESTA_PARAGRAFO_1":'Si precisa che nel campo "Repertorio" si inserisce la prima parte del campo "Repertorio - Numero" presente nel Modello 68 e nel campo "Raccolta/Anno/Altro" la seconda parte del medesimo campo solo se presente.'
          ,"RESTITUZIONE_DUPLO_RICHIESTA_PARAGRAFO_2":"Il duplo restituito non potrà esser richiesto più volte né dal medesimo soggetto né da soggetti differenti rispetto a chi lo ha richiesto la prima volta."
          ,"RESTITUZIONE_DUPLO_RICHIESTA_PARAGRAFO_3":"Nella sezione 'Ricerca Dupli restituiti' è possibile effettuare il download dei dupli richiesti tramite questo canale. "
          ,"WARNING_DUPLO_TEMPO":"È possibile effettuare la richiesta di restituzione del duplo tramite questo canale per le formalità presentate nel mese corrente e nei due precedenti , in caso contrario il duplo sarà restituibile solo presso l'ufficio di pubblicità immobiliare di competenza."
          ,"RESTITUZIONE_DUPLO_RICHIESTA_PARAGRAFO":"Per la restituzione del Certificato di eseguita formalità (Duplo), si inseriscano nei campi sottostanti i dati presenti nella 'Ricevuta di richiesta formalità (Modello 68)' o in caso di annotamento depositato i dati presenti nella 'Ricevuta di deposito annotamenti'."
          ,"RESTITUZIONE_DUPLO_RICHIESTA_PARAGRAFO_1":'Si precisa che nel campo "Repertorio" si inserisce la prima parte del campo "Repertorio - Numero"  e nel campo "Raccolta/Anno/Altro" la seconda parte del medesimo campo solo se presente.'
          ,"RESTITUZIONE_DUPLO_RICHIESTA_PARAGRAFO_1bis":'Nel caso in cui formalità prevede la restituzione del documento “Altra certificazione”, tale documento viene restituito  all’utente, insieme al documento "Duplo" tramite questo canale.'
          ,"RESTITUZIONE_DUPLO_RICHIESTA_PARAGRAFO_2":"I documenti restituiti non potranno essere richiesti più volte né dal medesimo soggetto né da soggetti differenti rispetto a chi lo ha richiesto la prima volta."
          ,"RESTITUZIONE_DUPLO_RICHIESTA_PARAGRAFO_3":"Nella sezione 'Ricerca Dupli restituiti' è possibile effettuare il download dei documenti richiesti. "
          ,"DATA":"Data"
          ,"DATI_RICHIESTA":"Dati Richiesta"
          ,"CODICE_FISCALE_ROGANTE":"Codice fiscale del rogante"
          ,"DATA_PRESENTAZIONE_ATTO":"Data di presentazione/deposito"
          ,"TIPO_FORMALITA":"Tipo formalità"
          ,"TIPO_RICHIESTA":"Tipo parametri richiesta"
          ,"PRESENTAZIONE":"Presentazione"
          ,"DEPOSITO":"Deposito"
          ,"CONSERVATORIA":"Ufficio"
          ,"REPERTORIO":"Repertorio"
          ,"REPERTORIO2":"Raccolta"
          ,"RACCOLTA":"Raccolta/Anno/Altro"
          ,"PROTOCOLLO":"Numero Pratica"
          ,"PROTOCOLLO_BIS":"Progressivo"
          ,"ANNO":"Anno"
          ,"DATI_FORMALITA":"Dati formalità"
          ,"DUPLO2":"Documenti"
          ,"STAMPA_NOTA":"Stampa della nota"
         


          ,"VALIDATION_CODICE_FISCALE_ROGANTE":"Il campo Codice fiscale del rogante è obbligatorio"
          ,"VALIDATION_CODICE_FISCALE_ROGANTE_INVALID":"Il campo Codice fiscale del rogante è errato"
          ,"VALIDATION_DATA_PRESENTAZIONE_ATTO":"Il campo Data di presentazione dell'atto  è obbligatorio"
          ,"VALIDATION_DATA_PRESENTAZIONE_ATTO_INVALID":"Il campo Data di presentazione dell'atto  è errato"
          ,"VALIDATION_CONSERVATORIA":"Il campo Ufficio è obbligatorio"
          ,"VALIDATION_REPERTORIO":"Il campo Repertorio è obbligatorio"
          
          ,"VALIDATION_PROTOCOLLO":"Il campo Numero Pratica  è obbligatorio"
          ,"VALIDATION_PROTOCOLLO_BIS":"Il campo Progressivo è obbligatorio"
          ,"VALIDATION_ANNO":"Il campo Anno è obbligatorio"

          
          ,"TRASMISSIONE_TITLE":"Invio nuovo documento"
          ,"DATI_INVIO":"Dati Invio"
          ,"IDENTIFICATIVO_MNEMONICO_PRATICA":"Identificativo mnemonico pratica"
          ,"DOMANDA":"Domanda"
          ,"TITOLO":"Titolo"
          ,"PROCURA":"Procura"
          ,"RICEVUTE_TITLE":"Ricevute"
          ,"ELENCHI_TITLE":"Elenchi esiti"
          ,"DATI_RICERCA":"Dati Ricerca"
          ,"DATA_INVIO":"Data Invio (gg/mm/aaaa)"
          ,"DAL":"Dal"
          ,"AL":"Al"
          ,"CODICE_INVIO":"Codice Invio"
          ,"DA":"Da"
          ,"A":"A"
          ,"STATO_INVIO":"Stato dell'invio"
          ,"FILTRI_APPLICATI":"Filtri applicati:"
          ,"CHIPS_FILTRO_DATE":"Dal {{dataDa}} al {{dataA}}"
          ,"CHIPS_FILTRO_CODICE_INVIO":"Da {{idPraticaDa}} a {{idPraticaA}}"
          ,"ELENCO_PEGNI":"Elenco pegni"
          ,"DETTAGLIO_CODICE_INVIO":"Codice Invio: {{idPratica}} - Identificativo mnemonico: {{idPraticaMittente}}"
          ,"DETTAGLIO_CODICE_INVIO_CI":"Elenco delle comunicazioni relative al documento inviato il {{timestampInvio}} - Codice Invio: {{idPratica}} "
          ,"DETTAGLIO_DOMANDA":"Domanda: {{numRep}}"
          ,"DETTAGLIO_SERIE":"Registrazione: Serie={{serieRegistrazione}}, Numero={{numeroRegistrazione}} del {{dataRegistrazione}}"
          ,"PROGRESSIVO":"Progressivo"
          ,"STATO":"Stato"
          ,"PROTOCOLLO_UFFICIO":"Numero pratica"
          ,"NUMERO_PRESENTAZIONE":"Numero presentazione"
          ,"NUMERO_GENERALE":"Numero iscrizione"
          ,"DUPLO":"Certificato di eseguita formalità"
          ,"DUPLO_NEGATIVO":"Domanda Rifiutata"
          ,"CAMBIA_CONVENZIONE":"Scegli il profilo"
          ,"CAMBIA_CONVENZIONE_DESC":"Seleziona uno fra i seguenti profili:"
          ,"CAMBIA_CONVENZIONE_DESC_MP":"Sei conosciuto al sistema come Pubblico Ufficiale abilitato ai servizi telematici di registrazione e di trasmissione di documenti ipotecari."
          ,"CAMBIA_CONVENZIONE_DESC_MP_1":"Seleziona il profilo con cui vuoi procedere, il sistema applicherà i controlli in coerenza col profilo scelto."
          ,"TIPO_CONVENNZIONE":"Codice fiscale"
          ,"REFERENTE":"Referente"

          ,"DETTAGLIO":"Dettaglio"
          ,"CODICE_INVIO":"Codice Invio"
          ,"IDENTIFICATIVO_UNIVOCO_UTC":"Identificativo Univoco (UTC)"
          ,"IDENTIFICATIVO_MNEMONICO":"Identificativo Mnemonico"
          ,"DATA_TRASMISSIONE":"Data Trasmissione"
          ,"STATO_PRATICA":"Stato Pratica"
          ,"ANOMALIE":"Anomalie"
          ,"ENTRATE":"Registrazione Atto"
          ,"PEGNI":"Registrazione pegno"
          ,"ANOMALIE_ENTRATE_PEGNI":"Registrazione titolo"
          ,"RICEVUTA_TRASMISSIONE":"Ricevuta Trasmissione"
          ,"RICEVUTA_PAGAMENTO":"Ricevuta Pagamento"
          ,"DOCUMENTO_INVIATO":"Documento Inviato"
          ,"CERTIFICATO_PRODOTTO":"Certificato Prodotto"
          ,"VALIDATION_FIELD_REQUIRED":"Il campo '{{nomeCampo}}' è obbligatorio"
          ,"VALIDATION_FIELD_NOT_VALID":"Il campo '{{nomeCampo}}' non è valido"
          ,"VALIDATION_NUMBER_ERROR":"Il campo '{{nomeCampo}}' deve essere un numero"
          ,"VALIDATION_DATA_AL_INVALID":"È  necessario specificare il range iniziale per il filtro di ricerca 'Data Invio' se valorizzato il campo 'Data Invio Al'"
          ,"VALIDATION_DATE_INVALID":"Il campo 'Data Invio {{nomeCampo}}' non è valido. Il formato corretto per le date è gg/mm/aaaa"
          ,"VALIDATION_DATE_INVALID_2":"Il campo '{{nomeCampo}}' non è valido. Il formato corretto per le date è gg/mm/aaaa"
          ,"VALIDATION_CODICE_INVIO_A_INVALID":"È  necessario specificare il range iniziale per il filtro di ricerca 'Codice Invio' se valorizzato il campo 'Codice Invio A'"
          ,"VALIDATION_CODICE_INVIO_INVALID":"Il campo 'Codice Invio {{nomeCampo}}' non è valido. Può contenere solo numeri per un massimo di 16"
          ,"VALIDATION_ONE_FIELD_MANDATORY":"È  obbligatorio specificare almeno un range tra 'Data Invio' e 'Codice Invio'"
          ,"VALIDATION_ONE_FIELD_MANDATORY_2":"È  obbligatorio specificare almeno un range tra 'Data Invio','Codice Invio' e 'Repertorio'"
          ,"VALIDATION_IDENTIFICATIVO_MNEMONICO_PRATICA":"Il campo 'Identificativo mnemonico pratica' è obbligatorio"
          ,"VALIDATION_IDENTIFICATIVO_MNEMONICO_PRATICA_INVALID":"Il campo 'Identificativo mnemonico pratica' contiene dei catteri non ammessi"
          ,"VALIDATION_FILE_DOMANDA_PEGNI":"È  necessario caricare la domanda di pegno"
          ,"VALIDATION_FILE_TITOLO_PEGNI":"È  necessario caricare il titolo"
          
          ,"TABLE_NO_RESULTS":"Non sono presenti risultati"
          ,"TABLE_AZIONI":"Azioni"

          ,"BUTTON_CONTROLLA":"Controlla"
          ,"BUTTON_SELEZIONA":"Seleziona"
          ,"BUTTON_MODIFICA":"Modifica"
          ,"BUTTON_RIMUOVI":"Rimuovi"
          ,"BUTTON_SALVA":"Salva"
          ,"BUTTON_RIPULISCI":"Ripulisci"
          ,"BUTTON_ANNULLA":"Annulla"
          ,"BUTTON_INVIA":"Invia"
          ,"BUTTON_RICHIEDI": "Richiedi"
          ,"BUTTON_VERIFICA":"Verifica"
          ,"BUTTON_CERCA":"Cerca"
          ,"BUTTON_RIMUOVI_FILTRO":"Rimuovi filtro"
          ,"BUTTON_TORNA_ELENCO_PRATICHE":"Torna a elenco pratiche"
          ,"BUTTON_TORNA_ELENCO_ADEMPIMENTI": "Torna all'elenco adempimenti"
          ,"BUTTON_TORNA_ELENCO_AVVISI":"Torna all'elenco avvisi"
          ,"BUTTON_VAI_A_DETTAGLIO":"Vai al Dettaglio"
          ,"BUTTON_DOWNLOAD_ENTRATE":"Download Documento Entrate"
          ,"BUTTON_DOWNLOAD_PEGNI":"Download Documento Pegni"
          ,"BUTTON_DOWNLOAD_RICEVUTA_TRASMISSIONE_P7M":"Download Ricevuta di Trasmissione - P7M"
          ,"BUTTON_DOWNLOAD_RICEVUTA_TRASMISSIONE_PDF":"Download Ricevuta di Trasmissione - PDF"
          ,"BUTTON_DOWNLOAD_RICEVUTA_PAGAMENTO_P7M":"Download Ricevuta di Pagamento - P7M"
          ,"BUTTON_DOWNLOAD_RICEVUTA_PAGAMENTO_PDF":"Download Ricevuta di Pagamento - PDF"
          ,"BUTTON_DOWNLOAD_RDP7M":"Download Ricevuta di Pagamento"
          ,"BUTTON_DOWNLOAD_P7M":"Download Documento Inviato"
          ,"BUTTON_DOWNLOAD_CER":"Download Certificato Prodotto"
          ,"BUTTON_SALVA_CONVENZIONE_BANCARIA":"Salva convenzione bancaria per utilizzi futuri"
          ,"BUTTON_AGGIUNGI_CONVENZIONE_BANCARIA":"Salva convenzione bancaria per utilizzi futuri"
          ,"BUTTON_DOWNLOAD_DUPLO":"Download Duplo"
          ,'ANOMALIA_NON_BLOCCANTE' : 'Anomalia non bloccante'
          ,"ANOMALIA_BLOCCANTE":"Anomalia bloccante"
          ,"RICEVUTA_DI_TRASMISSIONE":"Ricevuta di trasmissione non firmata "
          ,"RICEVUTA_DI_TRASMISSIONE_KO":"Ricevuta di scarto non firmata "
          ,"RICEVUTA_DI_TRASMISSIONE_FIRMATA":"Ricevuta di trasmissione firmata"
          ,"RICEVUTA_DI_TRASMISSIONE_FIRMATA_KO":"Ricevuta di scarto firmata "

          ,"DATA_RICHIESTA_DUPLO":"Data richiesta duplo"
          ,"DUPLI_RESTITUITI_TABLE_TITLE": "Dupli restituiti"
          ,"PLACEHOLDER_REPERTORIO_RACCOLTA":"Repertorio/Raccolta"
          ,"VALIDATION_CODICE_RICHIESTA_A_INVALID":"È  necessario specificare il range iniziale per il filtro di ricerca 'Codice Invio' se valorizzato il campo 'Codice Invio A'"
          ,"VALIDATION_CODICE_RICHIESTA_INVALID":"Il campo 'Codice Invio {{nomeCampo}}' non è valido. Può contenere solo numeri per un massimo di 16"
          ,"VALIDATION_ONE_FIELD_MANDATORY_DUPLO":"È  obbligatorio specificare almeno un range tra 'Data richiesta duplo' e 'Repertorio'"
          ,"CODICE_RICHIESTA":"Codice Richiesta"
          ,"DUPLI_RESTITUITI":"Ricerca dupli restituiti"
          ,"VALIDATION_REPERTORIO_RACCOLTA": "Il campo 'Repertorio {{nomeCampo}}' non è valido."
          
          ,"AVVISI": "Avvisi di pagamento"
          ,"DESTINAZIONE": "Destinazione"
          ,"REGISTRAZIONE": "Registrazione"
          ,"ANOMALIE_GENERALI": "Generali"
          ,"ANOMALIE_TERRITORIO": "Catasto"
          , "ANOMALIE_ENTRATE": "Entrate"
          , "ANOMALIE_CONSERVATORIE": "Pubblicità immobiliare"

          ,"CODICE_ATTO": "Codice atto"
          ,"PROGRESSIVO_AVVISO": "Progressivo avviso"
          ,"DENOMINAZIONE_UFFICIO": "Denominazione ufficio"
          ,"DATA_AVVISO": "Data emissione"
          ,"TIPO_AVVISO": "Tipo avviso"
          ,"TIPO_UFFICIO": "Tipo ufficio"
          ,"PAGAMENTO_INTEGRATIVO": "Pagamento Integrativo"


          ,"DATI_UTENTE":"Dati Utente"
          ,"TIPO_PUBBLICO_UFFICIALE":"Tipo Pubblico Ufficiale"
          ,"UFFICIO_ENTRATE":"Ufficio Entrate"
          ,"CODICE_FISCALE_PUBBLICO_UFFICIALE":"Codice Fiscale Pubblico Ufficiale"
          ,"DENOMINAZIONE_PUBBLICO_UFFICIALE":"Denominazione Pubblico Ufficiale"
          ,"PROVINCIA":"Provincia"
          ,"PROVINCIA_AMMINISTRATIVA":"Provincia Amministrativa"
          ,"PROVINCIA_CATASTALE":"Provincia Catastale"
          ,"SEZIONE_CENSUARIA":"Sezione Censuaria"
          ,"COMUNE":"Comune"
          ,"COMUNE_CATASTALE":"Comune catastale"
          ,"CAP":"Cap"
          ,"INDIRIZZO":"Indirizzo"
          ,"CONVENZIONE_BANCARIA":"Convenzione Bancaria"
          ,"CODICE_FISCALE_ENTE":"Codice Fiscale Ente"
          ,"CODICE_IBAN":"Codice IBAN"
          
          ,"VALIDATION_TIPO_PUBBLICO_UFFICIALE":"'Tipo Pubblico Ufficiale' non selezionato"
          ,"VALIDATION_DENOMINAZIONE_PUBBLICO_UFFICIALE":"'Tipo Pubblico Ufficiale' non inserita"
          ,"VALIDATION_UFFICIO_ENTRATE":"'Ufficio Entrate' non selezionato"
          ,"VALIDATION_CODICE_FISCALE_PUBBLICO_UFFICIALE":"'Codice Fiscale Pubblico Ufficiale' non inserito"
          ,"VALIDATION_COMUNE":"'Comune' non selezionato"
          ,"VALIDATION_CODICE_FISCALE_ENTE_INVALID": "'Codice Fiscale Ente' non valido. Deve contenere esattamente 11 caratteri numerici"
          ,"VALIDATION_CODICE_IBAN": "'Codice IBAN' non inserito"
          ,"VALIDATION_CODICE_IBAN_INVALID": "'Codice IBAN' non valido. Deve contenere 27 caratteri"
          ,"VALIDATION_CODICE_IBAN_EXISTS":"'Codice IBAN' già presente"
        

          
          ,"ABILITA_INSERIMENTO_ALTRI_IMPORTI":"Abilita inserimento altri importi"
          ,"IMPORTO_SANZIONI":"Importo sanzioni"
          ,"IMPORTO_INTERESSI":"Importo interessi"
          ,"IMPORTO_NOTIFICA":"Importo notifica"
          ,"IMPORTO":"Importo"
          ,"COMPILA":"Compila"
          ,"TABLE_CONVENZIONI_BANCARIE_NO_RESULTS": "Non sono presenti convenzioni bancarie memorizzate"
          ,"DOCUMENTO_AVVISO":"Avviso di pagamento"
          ,"DOCUMENTO_PREAVVISO":"Preavviso di pagamento"
          ,"ESITO_AVVISO":"Esito"
          ,"DATA_PAGAMENTO":"Data pagamento"
          ,"ELENCO_AVVISI":"Elenco avvisi"
          ,"ELENCO_ADEMPIMENTI": "Elenco adempimenti"
          ,"ELENCO_FORMALITA":"Elenco formalità"
          ,"FLAG_AVVISI":"Mostra solo pratiche che hanno prodotto avvisi di pagamento"

          ,"VISURA":"Visura"
          ,"ESITO":"Esito"
          ,"TIPO_NOTA":"Tipo nota"
          ,"RESTITUZIONE_DI_PARTE":"Restituzione di parte"
          
          ,"MESE":"Mese"
          ,"IRRICEVIBILI":"Irricevibili"
          ,"NON_ESEGUIBILI":"Non eseguibili"
          ,"ESEGUITE":"Eseguite"
          ,"INSERITE_IN_REGISTRO":"Inserite in registro"
          ,"DA_PROTOCOLLARE":"Da protocollare"
          ,"DA_LAVORARE":"Da lavorare"

          ,"RICEVUTA_ESECUZIONE":"Ricevuta esecuzione"
          ,"RICEVUTA_RICEZIONE":"Ricevuta ricezione"
          ,"PROTOCOLLO_PLICO":"Protocollo plico"
          ,"UFFICIO_DESTINAZIONE":"Ufficio destinazione"	
          ,"ENTE":"Ente"
          ,"TIPO_CANCELLAZIONE":"Tipo cancellazione"
          ,"STATO_CANCELLAZIONE":"Stato cancellazione"
          ,"DATA_PROTOCOLLO":"Data protocollo"
          ,"CODICE_PROTOCOLLO":"Protocollo"
          ,"DATA_ISCRIZIONE":"Data iscrizione"
          ,"NUMERO_ISCRIZIONE":"Numero iscrizione"
          ,"DATA_CANCELLAZIONE":"Data cancellazione"
          ,"ANOMALIE_UFFICIO":"Anomalie riscontrate"
          ,"ELENCO_CANCELLAZIONI":"Elenco cancellazioni"
          

          ,"FORMALITA_PRESENTATA":"Formalità presentata"
          ,"ANNOTAMENTO_DEPOSITATO":"Annotamento depositato"
          
          ,"PER_CONTO_DELL_ENTE": "Per conto dell'ente: "
          ,"PROFILO_ATTIVO": "Profilo attivo: "
          ,"CODICE_FISCALE":"Codice fiscale: "

        }
      }
    },
    lng: "it",
    fallbackLng: "it",

    interpolation: {
      escapeValue: false
    }
  });

  export default i18n;